// ==============================================
// ==================Import======================
// ==============================================

// ===================Dependancies================
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
// ==================Style&IMG===================
import './style.scss';

// ===================Actions=====================
import { downloadGeodeSymlFile, downloadSiteLogFile } from '../../../actions/dataAPI';
import { globalConfig } from '../../../configuration/config';

function Associated({ fullData }) {
  // ===========HOOK============
  const dispatch = useDispatch();
  return (
    <>
      <div className="metatitle"><span>Associated files</span></div>
      <div className="associated--list">
        <h1>Site Logs</h1>
        {fullData.map((elem) => (
          <div key={elem.marker}>
            {(elem.logs.length === 0)
            && (
            <div key={elem.iers_domes} className="associated--list__container--card">
              <p key={elem.name} className="no_associated">No SiteLogs</p>
            </div>
            )}
            {(elem.logs.length !== 0) && elem.logs.map((file) => (
              <div key={Object.keys(elem.marker_long_name)} className="associated--list__container--card">
                <p><span className="name">GeodesyML File: </span><button type="submit" onClick={() => dispatch(downloadGeodeSymlFile(elem.marker_long_name.toUpperCase(), globalConfig.config.REACT_APP_NODE_URL, globalConfig.config.REACT_APP_GLASS_API))} className="name--file">{file.title}</button></p>
                <p><span className="name">IGS Site log : </span><button type="button" onClick={() => dispatch(downloadSiteLogFile(elem.marker_long_name.toUpperCase(), globalConfig.config.REACT_APP_NODE_URL, globalConfig.config.REACT_APP_GLASS_API))} className="name--file">{elem.marker_long_name}.log</button></p>
              </div>
            ))}
          </div>
        ))}
      </div>
    </>
  );
}

Associated.propTypes = {
  fullData: PropTypes.arrayOf(
    PropTypes.shape({}),
  ).isRequired,
};

export default Associated;
